"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComponentInvisible = exports.shouldPopulateView = exports.isModeActive = exports.isImage = exports.isUrl = void 0;
var AutoModuleHardware_1 = require("../AutoModuleHardware");
function isUrl(component) {
    return (component.category === "software" &&
        component.type === "string" &&
        component.format === "url");
}
exports.isUrl = isUrl;
function isImage(component) {
    return (component.category === "software" &&
        component.type === "string" &&
        component.format === "image");
}
exports.isImage = isImage;
function isModeActive(mode, component, getComponent) {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = component === null || component === void 0 ? void 0 : component.mode) === null || _a === void 0 ? void 0 : _a.operation) !== mode) {
        return undefined; //No mode selected
    }
    var masterComponent = getComponent(component.mode.masterComponent);
    if ((_b = component.mode) === null || _b === void 0 ? void 0 : _b.matchRegEx) {
        var value = (_f = (_e = (_d = (_c = masterComponent === null || masterComponent === void 0 ? void 0 : masterComponent.value) === null || _c === void 0 ? void 0 : _c.toString()) === null || _d === void 0 ? void 0 : _d.match(component.mode.matchRegEx)) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
        return value > 0;
    }
    return undefined;
}
exports.isModeActive = isModeActive;
function shouldPopulateView(derivedFunctions, imports, getAssignedImport, config) {
    var _a;
    if (displayViewOnImportAssigned(getAssignedImport, config) === false) {
        return false;
    }
    return (((_a = derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions.shouldPopulateViewAtStartup) === null || _a === void 0 ? void 0 : _a.call(derivedFunctions)) === true ||
        (0, AutoModuleHardware_1.isFullyAssigned)(imports, config));
}
exports.shouldPopulateView = shouldPopulateView;
function displayViewOnImportAssigned(getAssignedImport, config) {
    var shouldPopulateView = true;
    if (config === null || config === void 0 ? void 0 : config.displayViewOnImportAssigned) {
        config.displayViewOnImportAssigned.forEach(function (impKey) {
            if (getAssignedImport(impKey) == undefined) {
                shouldPopulateView = false;
            }
        });
    }
    return shouldPopulateView;
}
var isComponentInvisible = function (component, appModel) {
    var _a, _b;
    var isInvisibleViaProperty = component.isVisibleProperty &&
        appModel.getDerivedFunction(component.isVisibleProperty) == false;
    return (((_b = (_a = appModel.getDerivedFunctions()).isVisible) === null || _b === void 0 ? void 0 : _b.call(_a, component.name)) === false ||
        isInvisibleViaProperty ||
        isModeActive("isVisible", component, appModel.getComponent) === false);
};
exports.isComponentInvisible = isComponentInvisible;
//# sourceMappingURL=autoModuleViewHelpers.js.map